import { z } from 'zod';
import { currencyCodeSchema, uuidSchema } from './index';

// Cada evento del feed de actividad. Los campos numéricos vienen como bigint
// desde Postgres (cents) y llegan como string por JSONB.
export const homeActivityEventSchema = z.object({
  kind: z.enum(['expense_created', 'settlement', 'member_added']),
  event_id: uuidSchema,
  group_id: uuidSchema,
  group_name: z.string(),
  group_emoji: z.string().nullable(),
  actor_id: uuidSchema.nullable(),
  actor_name: z.string().nullable(),
  // Ver `activity.ts`: mismo campo, mismo motivo para el `.default(null)`.
  actor_avatar_url: z.string().nullable().default(null),
  description: z.string().nullable(),
  merchant_name: z.string().nullable(),
  amount_cents: z
    .union([z.string(), z.number(), z.null()])
    .transform((v) => (v == null ? null : BigInt(v))),
  currency: currencyCodeSchema.nullable(),
  amount_target_ccy: z
    .union([z.string(), z.number(), z.null()])
    .transform((v) => (v == null ? null : BigInt(v))),
  event_at: z.string(),
  event_date: z.string(),
});
export type HomeActivityEvent = z.infer<typeof homeActivityEventSchema>;

export const homeGroupSummarySchema = z.object({
  group_id: uuidSchema,
  group_name: z.string(),
  group_emoji: z.string().nullable(),
  group_currency: currencyCodeSchema,
  is_archived: z.boolean(),
  balance_group_ccy_cents: z.union([z.string(), z.number()]).transform((v) => BigInt(v)),
  balance_target_ccy_cents: z.union([z.string(), z.number()]).transform((v) => BigInt(v)),
  last_activity_at: z.string().nullable(),
});
export type HomeGroupSummary = z.infer<typeof homeGroupSummarySchema>;

export const homeSummarySchema = z.object({
  target_currency: currencyCodeSchema,
  me: uuidSchema,
  summary: z.object({
    global_balance_cents: z.union([z.string(), z.number()]).transform((v) => BigInt(v)),
    active_groups_count: z.union([z.string(), z.number()]).transform((v) => Number(v)),
    archived_groups_count: z.union([z.string(), z.number()]).transform((v) => Number(v)),
  }),
  groups: z.array(homeGroupSummarySchema),
  recent_activity: z.array(homeActivityEventSchema),
});
export type HomeSummary = z.infer<typeof homeSummarySchema>;
